import React from "react";
import PropTypes from "prop-types";

const ConsentFormPage = ({ data, signatureData, staffSignatureData }) => {
  const defaultDate = new Date().toLocaleDateString();
  const currentDate = new Date().toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });

  const currentTime = new Date().toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true // set to false for 24-hour time
  });

  const consentLines = [
    "1. Consent: I voluntarily consent to this admission to Legacy Healing Center.",
    "2. Emergency Treatment and/or Hospital Transfer: I understand that while at Legacy Healing Center, the need for emergency treatment and/or transfer to a hospital may become necessary and appropriate. Should the need for such treatment and/or transfer be deemed necessary and appropriate by my attending physician, his/her assistants, and designees, I consent to such emergency treatment and/or transfer to a hospital and hereby indemnify Legacy Healing Center and its staff, or any physician who may be in attendance, from any loss resulting from such emergency treatment and/or transfer.",
    "3. Medical /Clinical Services Consent: I understand that I will be under the care of his/her attending physician, or the physician assigned by Legacy Healing Center, and the undersigned consents to examination and laboratory procedures. Medical treatment is rendered under the order of the physician or his/her designee. I authorize Legacy Healing Center to perform all clinical services deemed necessary in the evaluation of program/client appropriateness.",
    "4. Drug Screen Consent: I further understand that part of the treatment offered by Legacy Healing Center may require my submitting to urinalysis for drug/alcohol content, psychological testing, and other such similar procedures and that the consent that I have given in this document shall include, but not be limited to, the same. The results of urinalysis will be used for treatment planning purposes, will not be used for terminating treatment planning purposes, and will not be released without patient consent. Federal regulations prohibit making any further disclosure of this information unless expressly permitted by written consent of the person whom it pertains or as otherwise permitted by CFR 42, part 2. I agree to submit urine/take alcohol test, if requested, for drug testing. I understand that failure to do so could result in negative termination. Urine/alcohol results may be utilized as treatment interventions or may be completed as determined by external requirements.",
    "5. Conditions of Treatment: I acknowledge and understand that the practice of substance abuse treatment is not an exact science and that no promises or guarantees have been made to me regarding the outcome of my treatment by Legacy Healing Center. I do hereby absolve Legacy Healing Center from any liability if its treatment of my person is unsuccessful either in the short or long term or any events that may occur due to my addiction and/or treatment.",
    "6. Rules & Regulations: I hereby agree to comply with and abide by the policies, rules, and regulations of Legacy Healing Center in my treatment.",
    "7. Release of Information: I hereby agree that Legacy Healing Center may disclose all or any part of my Client Medical Records to any person or corporation which is or may be liable under a contract to Legacy Healing Center, or to the Client, or to a family member of Client, for all or part of the facility charges. Legacy Healing Center may further disclose all or said part of the Client's record to the referring doctor, hospital, clinic, and in case of minors, may disclose aftercare forms to the Client's school system.",
    "8. Personal Valuables: I hereby agree not to hold Legacy Healing Center liable for any loss of or damage to any money, jewelry, eyeglasses or contact lenses, dentures, documents, or any other articles of value.",
    "9. Drugs: I hereby agree that I will neither use nor keep any drugs or drug appliance/apparatus not prescribed by or on behalf of the attending physician. I agree to take all medications that are prescribed as directed by the physician during my stay at Legacy Healing Center. Any contraband found in my possession will be removed and destroyed.",
    "10. Photograph/Video Release: I understand and consent I will be under camera surveillance which includes videotaping for my safety and protection. I, consent to be photographed by Legacy Healing Center staff upon admission. These photographs are to remain as part of the permanent medical record and not otherwise disseminated without the client's specific consent. It is the policy of Legacy Healing Center that the photographing, camera surveillance, and videotaping is for therapeutic, safety, and security which will include but not be limited to exploration of incidents/conflicts and will be conducted upon consent of the client and only with approved equipment. I acknowledge that I may decline from being under camera surveillance while at Legacy Healing Center for my safety and protection. If I decline, I understand that I will not be allowed to remain in treatment.",
    "11. Federal Confidentiality: I have been advised and understand that Legacy Healing Center adheres to all Federal Laws of confidentiality and any suspected violations of the law must and will be reported.",
    "12. RIO after 90 days: I give my consent for the duration of my treatment and 90 days after discharge for Legacy Healing Center to release information regarding my progress and location in treatment to Referring Agencies, Probation and Officers of the Court for the purpose of assuring my compliance with an order for treatment (if requested).",
    "13. Fees: I understand that I am responsible for all fees for the duration of my program.",
    "14. Leaving against Staff Advice: I understand that if I leave Against Staff Advice and/or leave without notification of staff and that my whereabouts are unknown for over 2 hours, that the person on my Emergency Contact Form will be notified, that my whereabouts are unknown.",
  ];

  return (
    <div
      style={{
        fontFamily: "Arial",
        padding: "20px",
        maxWidth: "800px",
        margin: "0 auto",
        lineHeight: "1.2",
        height: "2400px",
        fontSize: "18px"
      }}
    >
      {/* Header Section */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
          lineHeight: "1.2",
        }}
      >
        <div>
          <p>
            <span style={{ fontWeight: "bold", display: "inline-block" }}>
              Client Name:
            </span>
            <span style={{ textTransform: "capitalize",borderBottom: "2px solid black",width: "150px",display: "inline-block"}}>{data.personalContact.firstName || "\u00A0"} {data.personalContact.lastName || "\u00A0"}</span>
          </p>
          <p>
            <span style={{ fontWeight: "bold", display: "inline-block" }}>
              Date:
            </span>
            <span style={{ textTransform: "capitalize",borderBottom: "2px solid black",width: "200px",display: "inline-block"}}>{data.date || defaultDate}</span>
          </p>
          <p>
            <span style={{ fontWeight: "bold", display: "inline-block" }}>
              Time:
            </span>
            <span style={{ textTransform: "capitalize",borderBottom: "2px solid black",width: "200px",display: "inline-block"}}>{currentTime}</span>
          </p>
        </div>
        <div>
          <p>
            <span style={{ fontWeight: "bold", display: "inline-block" }}>
              BP:
            </span>
            <span style={{ textTransform: "capitalize",borderBottom: "2px solid black",width: "150px",display: "inline-block"}}>{data.medicalLegal.bloodPressure}</span>
          </p>
          <p>
            <span style={{ fontWeight: "bold", display: "inline-block" }}>
              Temp:
            </span>
            <span style={{ textTransform: "capitalize",borderBottom: "2px solid black",width: "150px",display: "inline-block"}}>{data.medicalLegal.temperature}</span>
          </p>
          <p>
            <span style={{ fontWeight: "bold", display: "inline-block" }}>
              O2:
            </span>
            <span style={{ textTransform: "capitalize",borderBottom: "2px solid black",width: "150px",display: "inline-block"}}>{data.medicalLegal.oxygenLevel}</span>
          </p>
          <p>
            <span style={{ fontWeight: "bold", display: "inline-block" }}>
              Pulse:
            </span>
            <span style={{ textTransform: "capitalize",borderBottom: "2px solid black",width: "150px",display: "inline-block"}}>{data.medicalLegal.pulse}</span>
          </p>
          <p>
            <span style={{ fontWeight: "bold", display: "inline-block" }}>
              BA:
            </span>
            <span style={{ textTransform: "capitalize",borderBottom: "2px solid black",width: "150px",display: "inline-block"}}>{data.medicalLegal.bloodAlcohol}</span>
          </p>
          <p>
            <span style={{ fontWeight: "bold", display: "inline-block" }}>
              UA:
            </span>
            <span style={{ textTransform: "capitalize",borderBottom: "2px solid black",width: "150px",display: "inline-block"}}>{data.medicalLegal.urinalysis}</span>
          </p>
          <p>
            <span style={{ fontWeight: "bold", display: "inline-block" }}>
              REQ #:
            </span>
            <span style={{ textTransform: "capitalize",borderBottom: "2px solid black",width: "150px",display: "inline-block"}}>{data.medicalLegal.requestNumber}</span>
          </p>
        </div>
      </div>

      <div style={{ textAlign: "center" }}>
        <h2
          style={{
            display: "inline-block",
            fontSize: "20pt",
            fontFamily: "Elef Layla MF",
            marginBottom: "15px",
             borderBottom: '2px solid black',
             display: 'inline-block'
            
          }}
        >
          Legacy Healing Center
        </h2>
        <h3
          style={{
            display: "inline-block",
            fontSize: "20pt",
            fontFamily: "Elef Layla MF",
            marginBottom: "15px",
             borderBottom: '2px solid black',
             display: 'inline-block'
            
          }}
        >
          Consent For Treatment & Conditions of Admission
        </h3>
      </div>

      {/* Consent Items */}
      <div style={{ marginBottom: "30px" }}>
        {consentLines.map((line, index) => {
          const [numberAndTitle, ...contentParts] = line.split(":");
          const content = contentParts.join(":");

          return (
            <div key={index} style={{ marginBottom: "10px" }}>
              <span style={{ fontWeight: "bolder", display: "inline-block" }}>
                {numberAndTitle}
              </span>
              :{content}
            </div>
          );
        })}
      </div>

      {/* Signature Section */}
      <div style={{ marginTop: "40px" }}>
        {/* {signatureData && ( */}
          <div style={{ marginBottom: "30px" }}>
            <img
              src={signatureData || ""}
              alt="Client Signature"
              style={{
                width: "200px",
                height: "70px",
                borderBottom: "1px solid black",
              }}
            />
            <p>
              <span>Client Signature:</span>
            </p>
          </div>
        {/*  )} */}

        <div style={{ marginBottom: "20px" }}>
          {data?.medicalLegal?.staffFirstName} {data?.medicalLegal?.staffLastName}
          <div
            style={{
              borderBottom: "1px solid black",
              width: "200px",
              height: "30px",
            }}
          ></div>
          <p>Print staff name</p>
        </div>

        <div style={{ marginBottom: "20px" }}>
          {!currentDate && (
            <div
              style={{
                borderBottom: "1px solid black",
                width: "300px",
                height: "30px",
              }}
            ></div>
          )}
          <p>Date: {currentDate}</p>
        </div>

        {/* {staffSignatureData && ( */}
          <div style={{ marginBottom: "30px" }}>
            <img
              src={staffSignatureData || ""}
              alt="Staff Signature"
              style={{
                width: "200px",
                height: "70px",
                borderBottom: "1px solid black",
              }}
            />
            <p>
              <span>Staff Signature:</span>
            </p>
          </div>
        {/* )} */}
      </div>
    </div>
  );
};

ConsentFormPage.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    date: PropTypes.string,
    time: PropTypes.string,
    bp: PropTypes.string,
    temp: PropTypes.string,
    o2: PropTypes.string,
    pulse: PropTypes.string,
    ba: PropTypes.string,
    ua: PropTypes.string,
    req: PropTypes.string,
  }),
  signatureData: PropTypes.string,
  staffSignatureData: PropTypes.string,
};

ConsentFormPage.defaultProps = {
  data: {},
};

export default ConsentFormPage;
